export default "__VITE_ASSET__CZCGsKSV__"